/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Customproperties1Inputs */

const en_entity_customproperties1 = /** @type {(inputs: Entity_Customproperties1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Properties`)
};

const de_entity_customproperties1 = /** @type {(inputs: Entity_Customproperties1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Properties`)
};

/**
* | output |
* | --- |
* | "Custom Properties" |
*
* @param {Entity_Customproperties1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_customproperties1 = /** @type {((inputs?: Entity_Customproperties1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Customproperties1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_customproperties1(inputs)
	return de_entity_customproperties1(inputs)
});
export { entity_customproperties1 as "entity_customProperties" }